import { Select } from '@chakra-ui/react'
import { useState } from 'react'
import { getCountedColumns } from 'utlis/countedColumns'

export const ColumnSettingSelect = ({onChange, columns}) => {
       
       const [value, setValue] = useState ('')
             
    
    const handleSelect = (event) => {
          const selectedColumn = (columns.find(column => column.name === event.target.value))
            onChange(selectedColumn)
            setValue('')
        }
            

    return (
            <Select value={value} onChange={handleSelect}>
                <option value='' disabled hidden>Select Column</option>
                {columns.map ((column) => 
                <option key={column.name} value = {column.name}>{column.title}</option>
                 )
                }
                </Select> 
    )
}